import { Fragment } from 'react';
import { AlertCircle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogClose } from '@/components/ui/dialog';
import { Card, CardContent } from '@/components/ui/card';
import env from 'env';

type Props = {
  items: {
    id: string;
    title: string;
  }[];
};

const MigrationConnectFailure = ({ items }: Props) => {
  const onContactSupport = () => window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`, '_blank');

  return (
    <Fragment>
      <DialogHeader className="text-center gap-1.5">
        <div className="flex items-center justify-center size-12 shadow-sm rounded-md bg-card border mx-auto">
          <AlertCircle className="size-6 text-destructive" />
        </div>
        <DialogTitle className="text-xl font-bold">Migration failed!</DialogTitle>
        <DialogDescription>
          We couldn’t migrate these assets. Please migrate each of these assets individually, or contact support if you
          keep receiving this error.
        </DialogDescription>
      </DialogHeader>
      <Card className="bg-muted border-muted py-2 px-8">
        <CardContent className="p-2">
          <ul className="text-sm font-medium text-muted-foreground">
            {items.map((item) => (
              <li key={item.id}>{item.title}</li>
            ))}
          </ul>
        </CardContent>
      </Card>
      <DialogFooter className="sm:justify-center">
        <Button variant="outline" onClick={onContactSupport}>
          Contact support
        </Button>
        <DialogClose asChild>
          <Button>Back to Migrations</Button>
        </DialogClose>
      </DialogFooter>
    </Fragment>
  );
};

export default MigrationConnectFailure;
